module.exports = __webpack_public_path__ + "static/media/last_task_img.0d7a6705.svg";